import { useGetComentariosIncidenciaForReportQuery } from "src/gql/schema"
import { useProfile } from "src/shared/hooks/useProfile"
import { IncidenciaComentario } from "../IncidenciasDetail.type"

interface UseComentariosIncidenciaProps {
    folio?: number
    enabled: boolean
}

const useComentariosIncidencia = ({ folio, enabled }: UseComentariosIncidenciaProps) => {
    const { hotel_id } = useProfile()

    const { data, loading } = useGetComentariosIncidenciaForReportQuery({
        variables: { hotel_id, folio: Number(folio) },
        skip: !enabled || !folio || !hotel_id,
    })

    const comentarios: IncidenciaComentario[] = (data?.incidencias?.[0]?.comentarios || []).map((comentario, index) => ({
        id: `${index}`,
        fecha: comentario.fecha ? String(comentario.fecha) : null,
        comentario: comentario.comentario,
    }))

    return { comentarios, loading }
}

export default useComentariosIncidencia
